<template>
  <div class="d-flex home justify-content-center general">
    <Dashaboard class="isDesktop" />
    <!-- <Mobile class="isMobile" /> -->
  </div>
</template>

<script>
import Dashaboard from "../../components/Dashboard/Index-Dashboard.vue";
// import Mobile from "../../components/Dashboard/mobileDashboard.vue";

export default {
  components: {
    Dashaboard,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.isMobile {
  display: none !important;
}
@media screen and (max-width: 700px) {
  .isDesktop {
    display: none !important;
  }
  .isMobile {
    display: flex !important;
    flex-direction: column;
  }
}
</style>